import React from 'react';
import styled from 'styled-components';

interface IStarIconProps {
  user?: 'landlord' | 'tenant';
}

const StyledSvg = styled.svg<IStarIconProps>`
  display: block;

  path {
    fill: ${({ theme, user }) => user && theme.colors[user].main};
  }
`;

const Star = ({ user = 'landlord' }: IStarIconProps): JSX.Element => (
  <StyledSvg user={user} xmlns="http://www.w3.org/2000/svg" viewBox="0 4 16 16">
    <path
      d="M15.985 10.087a.316.316 0 00-.299-.227h-5.644L8.298 4.227A.316.316 0 008 4a.316.316 0 00-.298.227L5.957 9.86H.314a.316.316 0 00-.299.227.339.339 0 00.114.368l4.566 3.481-1.744 5.633a.338.338 0 00.114.368c.11.084.26.084.369 0L8 16.457l4.566 3.48a.304.304 0 00.369 0 .338.338 0 00.114-.368l-1.744-5.633 4.566-3.48a.338.338 0 00.114-.369zm-5.234 3.457a.338.338 0 00-.114.368l1.517 4.897-3.97-3.026a.304.304 0 00-.368 0l-3.97 3.026 1.516-4.897a.338.338 0 00-.113-.368l-3.97-3.026h4.906a.316.316 0 00.299-.227L8 5.395l1.516 4.896a.316.316 0 00.298.227h4.907l-3.97 3.026z"
      fill="#D2007E"
    />
  </StyledSvg>
);

export default Star;
